import { toSafeString } from '@shared/utils';
import isGeneratedFileArtifactDescriptor from '@shared/pieve/isGeneratedFileArtifactDescriptor.js';

const mapPublicShareItemsToActivity = (items) => {
  const activity = [];

  for (const item of Array.isArray(items) ? items : []) {
    const itemId = toSafeString(item?.id) || `shared-item-${activity.length + 1}`;
    const runId = toSafeString(item?.runId) || null;

    if (item?.type === 'message') {
      const role = toSafeString(item?.role).toLowerCase();
      const text = toSafeString(item?.text);

      if (!text) {
        continue;
      }

      activity.push({
        id: itemId,
        type: 'bubble',
        className: role === 'user' ? 'user' : '',
        lines: [{ text }],
        runId
      });
      continue;
    }

    if (item?.type === 'tool_call_summary') {
      const label = toSafeString(item?.label) || 'Working on your request';
      const toolCallId = toSafeString(item?.toolCallId) || itemId;

      activity.push({
        id: itemId,
        type: 'line',
        className: 'cmd',
        callId: toolCallId,
        toolCallId,
        toolName: toSafeString(item?.toolName),
        runId,
        segments: [{ text: label }]
      });
      continue;
    }

    if (item?.type === 'artifact_reference') {
      const artifactId = toSafeString(item?.artifactId);
      const title = toSafeString(item?.fileName);
      const mimeType = toSafeString(item?.mimeType);
      const resultFormat = toSafeString(item?.resultFormat);
      const surface = toSafeString(item?.surface);
      const toolName = toSafeString(item?.toolName).toLowerCase();

      if (!title || !mimeType || !isGeneratedFileArtifactDescriptor({ artifact: { artifactId, producerSucceeded: true, resultFormat, surface }, toolName })) {
        continue;
      }

      activity.push({
        id: itemId,
        type: 'artifactPreview',
        artifactId,
        title,
        mimeType,
        resultFormat: resultFormat || null,
        producerSucceeded: true,
        surface,
        rendererVersion: toSafeString(item?.rendererVersion) || null,
        callId: toSafeString(item?.toolCallId) || null,
        toolName: toolName || null,
        runId
      });
    }
  }

  return activity;
};

export default mapPublicShareItemsToActivity;
